export const GENERIC_SSO_ERROR =
  'There was a problem signing in with SSO, please speak with your account administrator.';
